import { useState } from '#app'

export const useMyLibrary = () => {
	type MyLibraryTab = {
		id: string
		name: string
	}
	const myLibraryTabs: MyLibraryTab[] = [
		{
			id: 'songs',
			name: 'Songs'
		},
		{
			id: 'playlists',
			name: 'Playlists'
		},
		{
			id: 'artists',
			name: 'Artists'
		},
		{
			id: 'song-history',
			name: 'Song history'
		}
	]

	const activeTab = useState<MyLibraryTab['id'] | null>('activeTab', () => null)

	return {
		myLibraryTabs,
		activeTab
	}
}
